/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for replay circle icon.
 *
 * @author Ramani Govindaraju
 */
const ReplayCircle = props => (
  <SvgIcon viewBox="0 0 90 90" {...props}>
    <path
      d="M25.366 62.024c4.48 4.808 10.57 7.579 17.14 7.811.29.008.586.012.875.012A24.56
      24.56 0 0 0 65.723 55.54a2.347 2.347 0 0 0-2.94-3.186 2.336 2.336 0 0 0-1.317
      1.221 19.876 19.876 0 0 1-18.798 11.573 19.783 19.783 0 0 1-13.875-6.323 19.78
      19.78 0 0 1-5.34-14.283 19.814 19.814 0 0 1 6.323-13.875 19.823 19.823 0 0 1
      14.28-5.34 20.21 20.21 0 0 1 14.602 7.038c2.438 2.847 3.964 6.285 4.534
      10.01l-4.016-4.568a2.344 2.344 0 0 0-3.522 3.093l8.224 9.357a2.33 2.33 0 0 0
      1.759.798c.052 0 .105-.003.154-.003a2.337 2.337 0 0 0 1.796-1.043l7.012-10.564a2.343
      2.343 0 1 0-3.907-2.587l-2.918
      4.395c-.746-4.425-2.628-8.52-5.557-11.936-4.523-5.273-11.078-8.434-17.993-8.674-6.566-.244-12.84
      2.111-17.643 6.596-4.808 4.481-7.583 10.571-7.815 17.141-.225 6.57 2.118 12.833 6.6
      17.644M45 0c24.855 0 45 20.149 45 45 0 24.855-20.145 45-45 45C20.149 90 0 69.854 0
      45 0 20.148 20.149 0 45 0"
    />
  </SvgIcon>
);

export default ReplayCircle;



// WEBPACK FOOTER //
// ./src/js/icons/ReplayCircle.jsx